<template>
    <main class="w-full mx-auto max-w-[1920px] relative">
      <div v-if="!isMobile" class="w-full h-full flex justify-center flex-wrap relative">

        <img src="/Sans titre-6-min.png" alt="home" class="w-[94%] pl-[3%] max-w-[1920px]" />

  <div class=" w-full flex justify-center mt-[-38%] ">

    <div class="bg-black/70 w-[30%] text-white  rounded-3xl !mb-[50px] p-[1%]">

        <Form
        class="uppercase"
      id="createForm"
      form_id="68dfa4e4243c47eb8c104bf2"
      server="https://api-gabarit.promo.dev"
      v-on:results="getResult"
      v-on:form_submit_loading="onLoading"
      :hideError="hiderror"
      @on_error="showErrorForm"
      :relay="relay"
    />

    </div>
  </div>

      </div>

      <div v-else class="block relative">
       <img src="@/assets/mob-min1.png" alt="home" class="w-full h-full object-cover max-w-[600px] mx-auto px-[5%] pt-[5%]" />

       <div class="relative">


        <div class="bg-black/70 w-[95%] mx-auto text-white  rounded-3xl !mb-[50px] p-[5%] relative">

<Form
class="uppercase"
id="createForm"
form_id="68dfa4e4243c47eb8c104bf2"
server="https://api-gabarit.promo.dev"
v-on:results="getResult"
v-on:form_submit_loading="onLoading"
:hideError="hiderror"
@on_error="showErrorForm"
:relay="relay"
/>

</div>

    
</div>
    </div>

    </main>
  </template>


<script setup lang="ts">
import router from "@/router";
import { ref, onMounted, onUnmounted } from "vue";

const hiderror = ref(true);
const loading = ref(false);
const error = ref(false);
const relay = ref();
const isMobile = ref(false);

const checkMobile = () => {
  isMobile.value = window.innerWidth < 1024;
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);

  // Observer pour détecter le chargement de Google Maps et afficher la clé
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === 'SCRIPT' && node.src && node.src.includes('maps.googleapis.com')) {
          const url = new URL(node.src);
          const apiKey = url.searchParams.get('key');
          console.log('🗺️ Google Maps API Key chargée:', apiKey);
          console.log('📍 Script source:', node.src);
        }
      });
    });
  });

  observer.observe(document.head, { childList: true, subtree: true });

  // Nettoyer l'observer après 5 secondes (le script devrait être chargé d'ici là)
  setTimeout(() => observer.disconnect(), 5000);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});


const onLoading = () => {
  loading.value = true;
};

const showErrorForm = (event) => {
  alert(event.error.message);
  loading.value = false;
  error.value = true;
};


const getResult = (result) => {
  if (result && result.status) {
    // result.status = "GAGNE";

    router.push({ name: "merci" });
  } else {
    alert("Une erreur est survenue, veuillez réessayer plus tard.");
  }
};



</script>
<style>
 #app[data-route="form"] {
  background: black;
  background-image: url('@/assets/fond.jpg') !important;
  background-size: 103% 120%;
  background-position: top center;
  background-repeat: no-repeat;
 
}

#isOver18_element, #opt_in_rules_element, #opt_in_privacy_element {
    @apply flex flex-row-reverse items-baseline justify-between;
}
#isOver18_element input, #opt_in_rules_element input, #opt_in_privacy_element input {
    @apply mr-[.5vw];
}

#opt_in_rules_element, #opt_in_privacy_element, .cannotfind {
  @apply text-[.8vw] leading-[1vw];
}

.cannotfind {
 @apply mt-[.5vw] normal-case text-right;
}

.text-rgpd, .mention {
    @apply text-[.4vw] leading-[.8vw] normal-case;
}

.input_wrapper_gender {
     @apply flex justify-start;
}

label {
    @apply text-white block w-full font-bold mt-[1vw] mb-[0.2vw];
}

label[for="civilite"] {
    @apply uppercase;
}

.error, .error_container {
    @apply text-yellow-500 text-[.8vw] w-full block mt-[.1vw];
}

.boxes {
    @apply w-[75vw] flex flex-wrap justify-start items-baseline;
}

.boxes input {
    @apply mx-[.5vw] inline-block;
}

.boxes label {
    @apply inline-block w-auto mr-[2vw];
}

input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="date"], input[type="time"], select, textarea {
 @apply  w-full  block rounded text-black py-[.3vw] pl-[.5vw];
}

#isOver18_element {
    @apply text-[.8vw] mt-0
}

.mention { 
    @apply text-[.6vw] mt-[1vw];
}

.builder-buttons {
    @apply mt-[1vw] text-center;
}


#next_button {
    @apply bg-[#E50032] py-[.5vw] px-[1.5vw] shadow-md font-bold mb-[1vw]  ;
}

@media screen and (max-width: 1023px) {
  #app[data-route="form"] {
    background-image: url('@/assets/fond-mob-min.jpg')  !important;
    background-size: 100% 71%;
  }

  #next_button {
    @apply text-[4vw] relative z-40;
}

.builder-buttons {
    @apply mt-[5vw];
}

.text-rgpd, .mention {
    @apply text-[1.2vw] leading-[3.3vw] normal-case;
}

.cannotfind {
 @apply text-[3.2vw] leading-[5vw];
}
label {
    @apply text-white block w-full font-bold mt-[4vw] mb-[1vw];
}

#isOver18_element, #opt_in_rules_element, #opt_in_privacy_element {
    @apply text-[3vw] leading-[3.8vw];
}


input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="date"], input[type="time"], select, textarea {
 @apply  w-full  block rounded text-black text-[4vw] leading-[4.8vw] py-[1vw] pl-[1vw];
}

.mention {
    @apply text-[3vw] leading-[6.8vw];
}


.boxes {
    @apply w-[70vw] justify-start items-baseline;
}

label[for="civilite"] {
    @apply uppercase w-[30vw];
}

.error, .error_container {
    @apply text-yellow-500 text-[2.8vw] w-full block mt-[1vw];
}

}

#opt_in_rules_element div  {
@apply inline-block;
}

</style>